import { Component, OnInit, NgZone, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';

import { FilterConfiguration } from '../../models';
import { CustomFormControl } from 'digital-core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.css']
})
export class FilterComponent implements OnInit {

  @Input() public filterConfiguration: FilterConfiguration;
  // tslint:disable-next-line:no-output-on-prefix
  @Output() public onClickSearch: EventEmitter<any> = new EventEmitter();
  // tslint:disable-next-line:no-output-on-prefix
  @Output() public onSelectSearchType: EventEmitter<any> = new EventEmitter();

  // tslint:disable-next-line:no-output-on-prefix
  @Output() public onClickCancel: EventEmitter<any> = new EventEmitter();

  FilterComponentForm = new UntypedFormGroup({
    filterInput: new CustomFormControl('', [
      Validators.required,
      Validators.minLength(1),
    ])
  });
  public searchType: string;
  public displayClearButton = false;
  searchTypeLabelText: string;

  constructor(
    public ngZone: NgZone) {
  }



  ngOnInit() {
    if (this.filterConfiguration) {
      this.searchTypeLabelText = this.filterConfiguration.searchTypeLabelText;
    }
    this.onChanges();
  }

  onChanges(): void {
  }

  onSelectFilterEvent(event: any) {
    this.onSelectSearchType.emit(this.searchType);
  }

  onCancel(event: any) {
    this.displayClearButton = false;
    this.FilterComponentForm.get('filterInput').setValue('');
    this.searchType = '';
    this.onClickCancel.emit(event);
  }


  onClickSearchEvent() {
    this.displayClearButton = true;
    this.onClickSearch.emit(this.FilterComponentForm.get('filterInput').value);
  }

  isValid() {
    return !this.FilterComponentForm.invalid && this.searchType && this.searchType !== "";
  }


}

